
import axios from 'axios'
import { url } from './url'
import queryStringUtil from "query-string";

function queryString(query) {
    var queryParams = {
        page: query.page,
        pageSize: query.pageSize,
        customer: query.customer,
    };
    return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket"
    });
}

function getQuotations(query) {
    var urlString = `${url}/quotations?${queryString(query)}`;
    return axios
        .get(urlString)
        .then(res => {
            return {
                total: res.data.total,
                quotations: res.data.quotations.map(quotation => {
                    return {
                        _id: quotation._id,
                        customer: quotation.customer,
                        createdAt: quotation.createdAt,
                        tecnicalService: quotation.tecnicalService,
                        hardwares: quotation.hardwares,
                        integration: quotation.integration,
                        tecnicalServiceTotalHourly: quotation.tecnicalServiceTotalHourly,
                        deliveryTimeWithMonth: quotation.deliveryTimeWithMonth,
                        validityTimeWithDay: quotation.validityTimeWithDay,
                        warrantyTimeWithYear: quotation.warrantyTimeWithYear,
                        privacySide: quotation.privacySide,
                    };
                })
            }
        });
}

function createQuotation(data) {
    return axios.post(`${url}/quotation`, data)
        .then(resp => {
            return resp.data
        })
}
function getQuotationHTML(data) {
    return axios.get(`${url}/quotation/${data._id}/${data.language}/html`)
        .then(resp => {
            return resp.data
        })
}
function deleteQuotation(id) {
    return axios.delete(`${url}/quotation/${id}`)
        .then(resp => {
            return resp.data
        })
}

export default {
    getQuotations,
    createQuotation,
    deleteQuotation,
    getQuotationHTML
};